import React, { Fragment } from 'react';
import SelectField from './SelectField';
import { showNotification } from './../../../utils';

const Form = React.memo((props) => {
    if (props.item == null) {
        return null;
    }

    let bullet1 = null;
    if (props.item.bullet1) {
        bullet1 = <li>{props.item.bullet1}</li>;
    }

    let bullet2 = null;
    if (props.item.bullet2) {
        bullet2 = <li>{props.item.bullet2}</li>;
    }

    let bullet3 = null;
    if (props.item.bullet3) {
        bullet3 = <li>{props.item.bullet3}</li>;
    }

    let bullet4 = null;
    if (props.item.bullet4) {
        bullet4 = <li>{props.item.bullet4}</li>;
    }

    let bullet5 = null;
    if (props.item.bullet5) {
        bullet5 = <li>{props.item.bullet5}</li>;
    }

    let bullet6 = null;
    if (props.item.bullet6) {
        bullet6 = <li>{props.item.bullet6}</li>;
    }

    let bullet7 = null;
    if (props.item.bullet7) {
        bullet7 = <li>{props.item.bullet7}</li>;
    }

    let bullet8 = null;
    if (props.item.bullet8) {
        bullet8 = <li>{props.item.bullet8}</li>;
    }

    const changeNotesHandler = (event) => {
        props.setNotes(event.target.value);
    };

    const handleSetProduct = (value) => {
        props.history.push('/nrc/' + value);
    };

    let quantityOptions = [{ value: '', label: 'Select option' }];
    quantityOptions.push({ value: 1, label: '1 Poster' });
    for (let i = 2; i <= 10; i++) {
        quantityOptions.push({ value: i, label: i + ' Posters' });
    }

    let imageOptions = [{ value: '', label: 'Select option' }]
    if (parseInt(props.templateCode) === 1) {
        imageOptions = [
            { value: 1, label: 'Image 1' },
            { value: 2, label: 'Image 2' },
        ]
    } else if (parseInt(props.templateCode) === 2) {
        imageOptions = [
            { value: 1, label: 'Image 1' },
            { value: 2, label: 'Image 2' },
            { value: 3, label: 'Image 3' },
            { value: 4, label: 'Image 4' },
        ]
    } else if (parseInt(props.templateCode) === 3) {
        imageOptions = [
            { value: 1, label: 'Image 1' },
            { value: 2, label: 'Image 2' },
            { value: 3, label: 'Image 3' },
        ]
    } else if (parseInt(props.templateCode) === 4) {
        imageOptions = [
            { value: 1, label: 'Image 1' },
        ]
    }

    const addToCartHandler = (type = 1) => {
        if (props.quantity === '') {
            return showNotification('Complete Information', 'Enter a quantity', 'info');
        }

        if (props.cxmlData.buyer_cookie == null) {
            props.addToCart(1, props.history, type);
        } else {
            props.addToCart(2, props.history, type);
        }
    };

    let buttonLabel = 'Checkout';
    if (props.addingToCart) {
        buttonLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Adding to Cart...</Fragment>;
    }

    let saveWorkLabel = 'Save Work';
    if (props.savingWork) {
        saveWorkLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Saving...</Fragment>;
    }

    let favoriteClasses = ['favorite-container'];
    let favoriteIcon = <i className="far fa-heart empty-heart" />;
    if (props.isFavorite) {
        favoriteClasses.push('active');
        favoriteIcon = <i className="fas fa-heart filled-heart" />
    }

    const handleAddFavorite = () => {
        props.addFavorite(props.history);
    };

    let shoppingCartButton = <button type="button" className="add-to-cart" disabled={props.addingToCart} onClick={addToCartHandler.bind(this, 1)}>{buttonLabel}</button>;
    if (props.action === 'edit') {
        shoppingCartButton = null;
    }

    return (
        <div className="form-container">
            <h5>Please make your selections below.</h5>
            <div className={favoriteClasses.join(' ')} onClick={handleAddFavorite}>
                {favoriteIcon} Favorites
            </div>
            <form action="">
                <hr />
                <SelectField
                    required
                    label="Product"
                    value={props.product}
                    setFunction={handleSetProduct}
                    options={[
                        { value: 1, label: 'Obstetric' },
                        { value: 2, label: 'Pediatric' },
                        { value: 3, label: 'Adult Medicine (English/Spanish)' },
                        { value: 4, label: 'Adult Medicine (Vietnamese/Mandarin)' },
                    ]}
                />
                <SelectField
                    required
                    label="Image"
                    value={props.image}
                    setFunction={props.setImage}
                    options={imageOptions}
                />
                <SelectField
                    required
                    label="Quantity"
                    value={props.quantity}
                    setFunction={props.setQuantity}
                    options={quantityOptions}
                />
                <hr />
                <div className="description-section">
                    <div className="mt-3"><b>Title: {props.item.name}</b></div>
                    <div className="mt-3">{props.item.description}</div>
                    <div className="description-list">
                        <ul>
                            {bullet1}
                            {bullet2}
                            {bullet3}
                            {bullet4}
                            {bullet5}
                            {bullet6}
                            {bullet7}
                            {bullet8}
                        </ul>
                    </div>
                </div>
                <hr />
                <div className="variable notes-field">
                    <div className="label">Notes:</div>
                    <textarea
                        value={props.notes}
                        onChange={changeNotesHandler}
                    />
                </div>
            </form>
            <div className="buttons-container">
                <button type="button" className="continue" onClick={addToCartHandler.bind(this, 2)} disabled={props.savingWork}>{saveWorkLabel}</button>
                {shoppingCartButton}
            </div>
        </div>
    );
});

export default Form;
